export class UploadUsersListSuccess {
    static readonly type = '[User] UploadUsersListSuccess';

    constructor(
        public payload: {
            asyncJobId: string;
        }
    ) {}
}
